import { useMemo } from "react";
import { advertiserOverview } from "../../core/data/advertiserOverview";

// advertiserOverview() for the SAME report data Market Overview uses (loaded
// once by useReportData), recomputed when the pin, filters or data change -
// never a new fetch. advertiserKey null = nothing pinned (the picker shows).
export default function useAdvertiserOverview(data, advertiserKey, filters) {
  const filtersKey = JSON.stringify(filters || {});
  return useMemo(
    () => (data && data.job ? advertiserOverview(data, advertiserKey || null, JSON.parse(filtersKey)) : null),
    [data, advertiserKey, filtersKey]
  );
}
